<template>
  <div
    class="m-0 flex h-full w-full flex-1 flex-col justify-between bg-gray-50 dark:bg-gray-900"
  >
    <settings-header
      v-if="!shouldHideHeaderForPhoenixInboxSettings"
      button-route="new"
      :icon="icon"
      :header-title="$t(headerTitle)"
      :button-text="$t(headerButtonText)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      :show-new-button="showNewButton"
      :show-sidemenu-icon="showSidemenuIcon"
    />
    <keep-alive v-if="keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-else />
  </div>
</template>

<script>
/* eslint no-console: 0 */
import { API_INBOX_TYPE } from 'shared/mixins/inboxMixin';
import SettingsHeader from './SettingsHeader.vue';

export default {
  components: {
    SettingsHeader,
  },
  props: {
    headerTitle: { type: String, default: '' },
    headerButtonText: { type: String, default: '' },
    icon: { type: String, default: '' },
    keepAlive: {
      type: Boolean,
      default: true,
    },
    newButtonRoutes: {
      type: Array,
      default: () => [],
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    showSidemenuIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    currentPage() {
      return this.$store.state.route.name;
    },
    showNewButton() {
      return this.newButtonRoutes.length !== 0 && !this.showBackButton;
    },
    shouldHideHeaderForPhoenixInboxSettings() {
      if (this.$store.state.route.name !== 'settings_inbox_show') {
        return false;
      }
      const inboxId = this.$store.state.route.params.inboxId;
      const inbox = this.$store.getters['inboxes/getInbox'](inboxId);
      if (!inbox) return false;
      const apiInboxType = inbox.additional_attributes?.apiInboxType;
      return apiInboxType === API_INBOX_TYPE.MSMAIL && !!inboxId;
    },
  },
};
</script>
